(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transportation', {
            parent: 'entity',
            url: '/transportation?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.transportation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transportation/transportations.html',
                    controller: 'TransportationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('transportation-detail', {
            parent: 'entity',
            url: '/transportation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.transportation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transportation/transportation-detail.html',
                    controller: 'TransportationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transportation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Transportation', function($stateParams, Transportation) {
                    return Transportation.get({id : $stateParams.id});
                }]
            }
        })
        .state('transportation.new', {
            parent: 'transportation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-dialog.html',
                    controller: 'TransportationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                cost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('transportation');
                });
            }]
        })
        .state('transportation.edit', {
            parent: 'transportation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-dialog.html',
                    controller: 'TransportationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Transportation', function(Transportation) {
                            return Transportation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transportation.delete', {
            parent: 'transportation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transportation/transportation-delete-dialog.html',
                    controller: 'TransportationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Transportation', function(Transportation) {
                            return Transportation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('transportation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
